<template>
    <div>
        <div class="mask-image">
            <img src="../assets/mask.png">
        </div>
        <div class="my-mask-order">
            <div class="my-mask-order-top">
                <div class="mask-order-info">
                    <img src="../assets/sketch-mask.png">
                </div>
                <div class="mask-order-info">
                    <div class="mask-name">Only U 医用外科口罩</div>
                    <div class="mask-for-send">送货上门</div>
                </div>
                <div class="mask-order-info order-info-right">
                    <span>x </span>
                    <span class="mask-order-num">
                    {{maskInfo.needCount}}
                </span>
                </div>
            </div>
            <div class="mask-order-notice">
                *   如需更多口罩，我们提供Only U品牌口罩购买服务，请直接联系一分钱客服：微信号：xiaodingdangshopping
            </div>
        </div>
        <div class="my-mask-apply">
            <div class="my-apply-type">
                <template v-if="maskInfo.status === 5">
                    <div class="apply-type-icon">
                        <img src="../assets/cancel.png">
                    </div>
                </template>
                <template v-else>
                    <div class="apply-type-icon">
                        <img src="../assets/order-yes.png" v-if="maskInfo.status > 0">
                        <img src="../assets/order-no2.png" v-else>
                    </div>

                    <img class="connect-icon" src="../assets/connect-line.jpg">

                    <div class="apply-type-icon">
                        <img src="../assets/pack-yes.png" v-if="maskInfo.status > 1">
                        <img src="../assets/pack-no.png" v-else>
                    </div>

                    <img class="connect-icon" src="../assets/connect-line.jpg">

                    <div class="apply-type-icon">
                        <img src="../assets/carriage-yes.png" v-if="maskInfo.status > 2">
                        <img src="../assets/carriage-no.png" v-else>
                    </div>

                    <img class="connect-icon" src="../assets/connect-line.jpg">

                    <div class="apply-type-icon">
                        <img src="../assets/confirm-yes.png" v-if="maskInfo.status > 3">
                        <img src="../assets/confirm-no.png" v-else>
                    </div>
                </template>
                <div class="mask-order-new-message">
                    <template v-if="maskInfo.progress">
                        <div :class="[index?'order-message-line':'order-message-line active']" v-for="(item,index) in maskInfo.progress" :key="index">
                            <span>
                                <img src="../assets/dot-h.png" v-if="index">
                                <img src="../assets/dot-l.png" v-else>
                            </span>
                            <span>{{item}}</span>
                        </div>
                    </template>
                </div>
            </div>
        </div>
        <div class="consignee-information">
            <div class="consignee-information-title">送货地址</div>
            <div class="consignee-information-box">
                <div class="consignee-name">{{maskInfo.realName}}</div>
                <div class="consignee-info">{{maskInfo.mobile}}</div>
                <div class="consignee-info">{{maskInfo.needAddress}}</div>
                <div class="consignee-info">{{maskInfo.zipCode}} {{maskInfo.city}}</div>
            </div>
        </div>
        <div class="my-apply-hint">
            <div class="hint-list">
                <div class="hint-list-punctuation">*</div>
                <div class="hint-list-text">
                    配送费由您自行承担：小巴黎地区送货上门，配送费5欧起，其余地区邮寄，邮费7欧起
                </div>
            </div>
            <div class="hint-list">
                <div class="hint-list-punctuation">*</div>
                <div class="hint-list-text">免费口罩每人限领一次，由于参与人数较多请耐心等待配送</div>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    import { Slider } from 'vant';
    Vue.use(Slider);
    export default {
        data(){
            return {
                maskInfo:this.$store.state.userMask
            }
        },
        created(){
            if(!this.$store.state.userMask){
                this.$axios.get('/api/service/mask/info').then(res => {
                    if(res.data.data.status){
                        this.maskInfo = res.data.data;
                    }
                }).catch(error => {
                    console.log(error);
                    // this.$router.push("/error")
                });
            }
        },
        methods:{
        },
        destroyed(){
            this.$store.commit('setUserMask', []);
        }
    }
</script>
<style>
    .my-apply-hint::before{
        content:" ";
        position:absolute;
        left:0;
        right:0;
        top:0;
        bottom:0;
        background-color:#f3f3f3;/* 颜色自定义 */
        z-index:-100;/* 突然想到个游戏，是男人就下100层。。。 */
    }
    .mask-order-new-message img{
        width: 7px;position: relative;top: -2px;
    }
    .consignee-information-title{
        font-size: 14px;
        color: #ffdc3a;
        padding-bottom: 10px;
        border-bottom: 1px solid #e0e0e0;
        padding-top: 10px;
    }
    .consignee-information-box{
        overflow: hidden;
    }
    .consignee-name{
        font-weight: 600;
        color: #4a4a4a;
        font-size: 14px;
        padding: 8px 0;
    }
    .consignee-info{
        color: #4a4a4a;
        padding-bottom: 5px;
        word-wrap: break-word;
        word-break: normal;
        font-size: 13px;
    }
    .consignee-information{
        padding: 10px 25px 20px;
        background-color: #fff;
    }
    .mask-order-new-message .order-message-line{
        padding-left: 15px;
    }
    .order-message-line.active{
        color: #ffdc3a;
    }
    .order-message-line{
        padding: 5px 0;
        font-size: 13px;
        color: #4a4a4a;
    }
    .order-message-line span{
        padding-right: 12px;
    }
    .mask-order-new-message{
        width: 90%;
        margin: 15px auto 0;
        text-align: left;
        border-top: 1px solid #e0e0e0;
        padding: 11px 0;
    }
    .my-mask-order{
        margin: 7px 0 7px 0;
        background-color: #fff;
        padding: 0 27px;
    }
    .my-mask-order-top{
        overflow: hidden;
        border-bottom: 1px solid #f3f3f3;
    }
    .mask-order-notice{
        font-size: 12px;color: rgb(155,155,155);
        padding: 14px 14px 17px;
    }
    .mask-order-info{
        display: inline-block;float: left;
    }
    .order-info-right{
        float: right;
        line-height: 85px;
        padding-right: 20px;
        font-size: 14px;
        color: #4a4a4a;
    }
    .mask-order-num{
        font-weight: 600;
    }
    .mask-name{
        margin-top: 17px;color: #4a4a4a;font-size: 14px;font-weight: 600;
    }
    .mask-for-send{
        margin-top: 10px;
        color: #4a4a4a;
        font-size: 13px;
    }
    .mask-order-info img{
        position: relative;
        width: 5rem;
        padding: 1rem;
    }
    .van-nav-bar{
        background-color: yellow;
    }
    .mask-image img{
        width: 100%;
    }
    .my-mask-apply{
        background-color: #fff;
        margin: 7px 0 7px 0;
        padding: 20px 10px 0;
    }
    .my-mask-apply .van-slider{
        top: 20%;
        margin: 0 auto;
        width: 80%;
    }
    .my-apply-type{
        text-align: center;
        position: relative;
        font-size: 0.8rem;
    }
    .connect-line{
        position: absolute;
        top: 50%;
    }
    .apply-type-icon{
        display: inline-block;
        font-size: 0;
    }
    .apply-type-icon div{margin-top: 8px}
    .apply-type-icon img{
        width: 43px;
    }
    .connect-icon{
        position: relative;
        top: -2px;
        width: 40px;
    }
    .my-apply-title{
        padding: 20px 10px;
        font-size: 1.0rem;
    }
    .my-apply-hint{
        font-size: 12px;
        padding: 8px 20px;
        height: 100px;
        color: #646566;
    }
</style>
